import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';
import { filterAdminRouters, routes } from 'router';
import { renderRoutes } from './renderRoutes';

const Guard = () => {
  const userInfo = useSelector((state) => state.global.userInfo);
  return (
    <Suspense fallback={null}>
      <Switch>
        {renderRoutes(filterAdminRouters(routes, userInfo?.accountInfo.accountId ?? ''))}
      </Switch>
    </Suspense>
  );
};

export default Guard;
